import Vue from 'vue'
// MOMENTJS
import moment from 'moment'
export default Vue.mixin({
	methods: {
		timeConvert: function(num) {
			var hours = Math.floor(num / 60);  
			var minutes = num % 60;
			if (isNaN(hours) || isNaN(minutes)) {
				return ' '
			}
			return hours + ":" + minutes;         
		},
		humanDate: function(timestamp) {
			return moment(timestamp)
		},
	}
})